import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Signature } from '../../models/signature';
import { Person } from '../../models/person';
import { faSave } from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-electronic-entry-signature',
  templateUrl: './electronic-entry-signature.component.html',
styleUrls:  ['./electronic-entry-signature.component.css']
})
export class ElectronicEntrySignatureComponent implements OnInit {

  faSave = faSave;

  copy_confirmed: boolean = false;
  copied_from_role: string = '';

	@Input() existing_signatures: Signature[];
  @Input() signature: Signature;
	@Input() person: Person;
	@Input() role: string;
	@Input() display_save: boolean = false;
  @Input() allow_email_request = true;
  @Input() require_contact_consent = true;
  @Output() save_clicked$: EventEmitter<Signature> = new EventEmitter<Signature>();

  constructor() {}

  ngOnInit() {}

  private get copy_source(): Signature | undefined {
    if (!this.person?.id || !this.existing_signatures?.length) return undefined;
    if (this.signature?.accepted_terms || this.signature?.signature?.length > 0) return undefined;
    return this.existing_signatures.find(exsig =>
      exsig.user_person_id === this.person.id &&
      exsig.accepted_terms &&
      exsig.signature?.length > 0 &&
      exsig !== this.signature
    );
  }

  get offer_copy(): boolean {
    return this.copy_source != null;
  }

  get copy_source_role(): string {
    const src = this.copy_source;
    if (!src?.party_to_entry) return 'another role';
    return src.party_to_entry.charAt(0) + src.party_to_entry.slice(1).toLowerCase();
  }

  handleCheck($event) {
    if (this.signature.request_signature) {
      this.signature.request_signature_email = this.person.email;
    }
  }

  handleSaveChanges(signature: Signature) {
    this.save_clicked$.emit(signature);
  }

  handleCopy() {
    const src = this.copy_source;
    if (!src) return;
    this.copied_from_role = src.party_to_entry
      ? src.party_to_entry.charAt(0) + src.party_to_entry.slice(1).toLowerCase()
      : 'another role';
    this.signature.accepted_terms = src.accepted_terms;
    this.signature.signature = src.signature;
    this.signature.read_document = src.read_document;
    this.signature.contact_consent = src.contact_consent;
    this.copy_confirmed = true;
  }

}
